import { Input, KeyCode } from "../../lib/Input";
import SPAbility from "../SPAbility";
import SPPlayer from "../SPPlayer";

export default class Berserk extends SPAbility {
    constructor(player: SPPlayer) {
        super(player, {
            cooldown: 30,
            duration: 10,
            icon: 7,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyDown
        });
    }

    onDurationEnd(): void {
        this.player.gun.damage-=6;
    }

    onUse(): void {
        this.player.gun.damage+=6;
    }
}